import React from 'react'
import BlockContent from '@sanity/block-content-to-react'
import {GatsbyImage} from "gatsby-plugin-image";
import {Link} from "gatsby";
import Footer from "../components/footer";


const serializers = {
    types: {
        code: props => (
            <pre data-language={props.node.language}>
        <code>{props.node.code}</code>
      </pre>
        )
    }
}

const Article = ({pageContext,data}) =>{
    console.log(pageContext);

    return (
        <>
        <title>{pageContext.title}</title>
        <header>
            <Link to={"/"}>&lt; Til hele oversikten</Link>
        </header>
        <main>
            {pageContext.image && pageContext.image.asset && pageContext.image.asset.url &&
                <>
                    <img src={pageContext.image.asset.url + "?w=1200"}/>
                    {pageContext.image_text &&
                        <p>{pageContext.image_text}</p>
                    }
                </>
            }

            <h1>{pageContext.title}</h1>

            {pageContext.intro &&
                <p>
                    <strong>{pageContext.intro}</strong>
                </p>
            }

            {pageContext.main_link &&
                <a target="_blank" rel="noopener noreferer nofollow" href={pageContext.main_link}>Registrer deg her &raquo;</a>
            }

            {pageContext.content &&
                <BlockContent blocks={pageContext.content} serializers={serializers}/>
            }
        </main>
        <Footer/>
        </>
    )
}

export default Article
